<template>
    <div class="bin-box">
        <div class="box-head">
            <div style="width: auto;display: flex;align-items: center;">
                <span style="width:100px;">名称：</span>
                <el-input v-model="name" placeholder="请输入名称" style="margin-left:1vw;"></el-input>
                <el-button type="primary" @click="doFilter" style="margin-left:1vw;">查询</el-button>
            </div>
            <div>
                <el-button type="primary" @click="addFun">新增</el-button>
            </div>
        </div>
        <div class="box-main">
            <el-table
                :data="tableDataEnd"
                stripe
                height="100%"
                style="width: 100%;"
                :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
                >
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="80">
                    <template slot-scope="scope">
                    <span>{{ scope.row.index }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="ID">
                    <template slot-scope="scope">
                    <a>{{ scope.row.id}}</a>
                    </template>
                </el-table-column>
                <el-table-column label="名称">
                    <template slot-scope="scope">
                    <a>{{ scope.row.name}}</a>
                    </template>
                </el-table-column>
                <el-table-column label="顺序">
                    <template slot-scope="scope">
                    <a>{{ scope.row.sort}}</a>
                    </template>
                </el-table-column>
                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
            ></el-pagination>
        </div>
        <!-- 新增窗口 -->
        <el-dialog
            :title="addTitle"
            :visible.sync="addFormVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="700px"
        >
            <el-form
            :model="addForm"
            ref="addForm"
            label-width="100px"
            :label-position="labelPosition"
            :rules="rules"
            >
                <el-form-item label="名称：" prop="name">
                    <el-input v-model="addForm.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="地址：" prop="url" style="width:100%;">
                    <el-input v-model="addForm.url" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="排序：" style="width:100%;">
                    <el-input v-model="addForm.sort" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
            <el-button @click="addFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
    data(){
        return{
            name:'',
            tableDataEnd:[],
            groupId:'',
            //弹出框
            addFormVisible:false,
            addForm:{
                name:'',
                url:'',
                sort:''
            },
            addTitle:'',
            labelPosition:'right',
            rules:{
                name:[{ required: true, message: '请输入名称', trigger: 'blur' }],
                url:[{ required: true, message: '请输入地址', trigger: 'blur' }],
            },
            currentPage:1,
            pageSize:10,
            totalItems:0,
            dataText:'数据加载中...',
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getData()
    },
    methods:{
        handleSizeChange(val) {
          this.pageSize = val
          this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
          console.log(`当前页: ${val}`)
          this.currentPage = val
          this.getData()
        },
        // 监控当前页码
        currentChangePage() {
          this.getData()
        },
        //查询
        doFilter(){
            this.currentPage = 1
            this.getData()
        },
        //获取列表
        getData(){
            var that = this
            myHttp.selectProProjectBimPage({
                pageNum:this.currentPage,
                pageSize:this.pageSize,
                projectId:this.groupId,
                name:this.name
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                    }
                    that.tableDataEnd = list
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },

        //增加
        addFun(){
            this.addFormVisible = true
            this.addTitle = '增加数据'
            this.addForm.id = ''
            this.addForm.name = ''
            this.addForm.url = ''
            this.addForm.sort = ''
        },

        //提交
        sumbitAddRow(formName){
            var that = this
            this.addForm.projectId = this.groupId
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if(that.addForm.id==''){
                        this.addForm.createBy = util.session.get('user').id
                        myHttp.createProProjectBim(that.addForm).then(function(resp){
                            if(resp.data.code=='200'){
                                that.addFormVisible = false
                                that.$message.success("添加成功")
                                that.getData()
                            }else{
                                that.$message.error(resp.data.msg)
                            }
                        })
                    }else{
                        that.addForm.updateBy = util.session.get('user').id
                        myHttp.updateProProjectBim(that.addForm).then(function(resp){
                            if(resp.data.code=='200'){
                                that.addFormVisible = false
                                that.$message.success("修改成功")
                                that.getData()
                            }else{
                                that.$message.error(resp.data.msg)
                            }
                        })
                    }
                }else{
                    
                }
            })
        },

        //编辑
        handleEdit(index,row){
            this.addFormVisible = false
            this.addTitle = '修改数据'
            this.addFormVisible = true
            var that = this
            myHttp.getProProjectBim({
                id:row.id
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.proProjectBim
                    if(data){
                        that.addForm.id = data.id
                        that.addForm.name = data.name
                        that.addForm.url = data.url
                        that.addForm.sort = data.sort
                    }
                }
            })
        },

        //删除
        handleDelete(index,row){
            var that = this
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.deleteProProjectBimLj({
                    id: row.id,
                    updateBy:util.session.get('user').id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('删除成功')
                        that.getData()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                })
            })
        },
    }
}
</script>

<style scoped>
    .bin-box{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh;
    }
    .box-head{
        width: 100%;
        height: 5vh;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        background: #fff;
        padding: 0 1vw;
    }
    .box-main{
        width: 100%;
        height: calc( 100% - 11vh );
        margin-top: 1vh;
        position: relative;
        background: #fff;
    }
</style>

<style>

</style>